import { render, staticRenderFns } from "./VotingClosed.vue?vue&type=template&id=9d4ef7c0"
import script from "./VotingClosed.vue?vue&type=script&lang=js"
export * from "./VotingClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports